import React from "react"
import Select from "react-select"
import { SelectOption } from "../../../../state/helpers/SelectOption"
import { MatrixAxis } from "../../../../state/product/matrix/Matrix"
import { FilteredOptionsIds, SelectedOptionsIds } from "./MatrixSelection"

type Props = {
    axis: MatrixAxis
    filteredOptionsIds: FilteredOptionsIds
    selectedOptionsIds: SelectedOptionsIds
    displayRow:boolean
    onSelectChange: (axis: MatrixAxis, axisOptionSelected: SelectOption) => void
    isDisabled: boolean,
}

const MatrixAxisOptionsSelect = (props: Props) => {

    const availableOptions = props.axis.options.filter(option => props.filteredOptionsIds[props.axis.type].includes(option.id))

    const selectOptions: SelectOption[] = availableOptions.map(o => ({
        value: o.id,
        label: o.attributes.name,
    }))

    const defaultValue = selectOptions[0]?.value
    const value = selectOptions.find(o => o.value === props.selectedOptionsIds[props.axis.type])

    return (
        <div className={`${props.displayRow?"col-auto ":""}form-group form-row`} key={props.axis.type}>
            <label className={props.displayRow?"col-auto text-align-right":"col-sm-6 col-md-5 col-form-label text-align-right"}>
                {props.axis.name}
            </label>
            <div className={props.displayRow?"col-auto":"col-sm-6 col-md-7"} style={props.displayRow?{minWidth:"200px"}:{}}>
                <Select
                    name={`axis-option-${props.axis.type}`}
                    className="basic-single"
                    classNamePrefix="select"
                    defaultValue={defaultValue}
                    value={value}
                    options={selectOptions}
                    onChange={(optionSelected: SelectOption) => props.onSelectChange(props.axis, optionSelected)}
                    disabled={props.isDisabled}
                />
            </div>
        </div>
    )

}

export default MatrixAxisOptionsSelect


// WEBPACK FOOTER //
// ./src/common/pricing/add-item-modal/components/MatrixAxisOptionsSelect.tsx